<template>
  <div class="form-item">
    <div class="form-item__label"
     :class="{ 'info-popup': description, fit: fit, 'm-0':noSpace }">
      {{ $t(title) }}

      <svg
        v-if="description"
        v-svg
        style="min-width: fit-content"
        v-tooltip="{
          content: $t(`${description}`),
          triggers: ['hover', 'click'],
        }"
        symbol="info"
        size="0 0 18 18"
        role="info"
      ></svg>
    </div>
    <p v-if="hint" class="form-item__hint">{{ $t(hint) }}</p>
    <div class="form-item__field" :class="{'m-0':noSpace}">
      <div class="form-item-number" :class="{'invalid': invalid}"> 
        <input :ref="title" type="number" :value="data" @blur="setData($event)" @focus="selectValue" :disabled="disabled" />
        <small v-if="placeholder">{{ placeholder }}</small>
        <small v-if="infinity" class="infinity">{{ placeholder }}</small>
        <button @click="increment" :disabled="value >= max || disabled" class="form-item-number__btn icon-a-up" :title="$t('increase')">
          <svg v-svg role="presentation" size="0 0 10 10" symbol="prev"></svg>
        </button>
        <button @click="decrement" :disabled="value <= min || disabled" class="form-item-number__btn icon-a-down" :title="$t('decrease')">
          <svg v-svg role="presentation" size="0 0 10 10" symbol="next"></svg>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Counter",
  props: {
    infinity: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default:false
    },
    noSpace: {
      type: Boolean,
      default:false
    },
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    fit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", +newVal);
      },
    },
  },
  watch: {
    infinity: {
      handler(val){
        if (val) this.data = 1000000
    },
    immediate: true
    }
  },
  methods: {
    selectValue() {
      setTimeout(() => {
        this.$refs[this.title].select();
      }, 100);
    },
    setData(event) {
      const value = +event.target.value;
      if (value > this.max) {
        event.target.value = this.max;
      } else if (value <= this.min) {
        event.target.value = this.min;
      } else {
        event.target.value = Math.trunc(+String(value).replace(/^(0{2,})/g, "0"));
      }
      this.data = event.target.value;
    },
    decrement() {
      if (this.data >= this.min) this.data--;
    },
    increment() {
      if (this.data <= this.max) this.data++;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

small.infinity {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 11px;
  border-radius: 10px;
  font-size: 16px;
  color: #909090;
  top: 0 !important;
  left: 0 !important;
  background: #f4f4f4;
}

.form-item-number__btn {
  svg {
    transform: rotate(90deg);
  }
  &:hover {
    svg {
      fill: white;
    }
  }
}
.form-item-number {
  border: 1px solid transparent;
  input {
    border-radius: 10px;
  }
  &.invalid {
    border: 1px solid red;
    border-radius: 11px;
  }
  small {
    top: 14px;
    right: 50px;
    position: absolute;
  }
}
</style>
